export default __webpack_public_path__ + "static/zen-advisor-about-24564b5c57c50384ab8229f65aa6ff9c.png";